import React, { useState } from 'react';
import { Accordion, Typography } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { Configure, Index } from 'react-instantsearch';
import { TableRefresh } from '../table/TableRefresh';
import { FolioErrorBoundary } from '@/components/layouts/FolioErrorBoundary';
import TaskGroupContent from './TaskGroupContent';

export const CollapsibleTaskGroup = ({ displayCard = true, ...props }) => {
	const { dealId, clientId, relationshipCompanyId } = useObjectContext();
	const [expanded, setExpanded] = useState(true);

	if (!dealId && !clientId && !relationshipCompanyId) {
		return (
			<Typography sx={{ py: 1, px: 0 }} color='text.secondary'>
				No tasks available
			</Typography>
		);
	}

	const filterSchema = {
		filters: relationshipCompanyId
			? `relationshipCompanyId := ${relationshipCompanyId} && completed:=false`
			: dealId
				? `dealId := ${dealId} && completed:=false`
				: `clientId := ${clientId} && completed:=false`,
	};

	return (
		<FolioErrorBoundary
			dealId={dealId}
			clientId={clientId}
			key={`${relationshipCompanyId ?? ''}-${dealId ?? ''}-${clientId ?? ''}`}
			message='Error loading tasks'
			context='CollapsibleTaskGroup'
		>
			<Index indexName='tasks'>
				<Configure {...filterSchema} />
				<TableRefresh table={'taskTable'} />
				<Accordion
					elevation={0}
					disableGutters
					square
					expanded={expanded}
					sx={{
						backgroundColor: 'transparent',
						width: '100%',
						'&:not(:last-child)': {
							borderBottom: 0,
						},
						'&::before': {
							display: 'none',
						},
					}}
					onChange={() => {
						setExpanded((prev) => !prev);
					}}
				>
					<TaskGroupContent
						{...{
							expanded,
							displayCard,
							...props,
						}}
					/>
				</Accordion>
			</Index>
		</FolioErrorBoundary>
	);
};
CollapsibleTaskGroup.displayName = 'CollapsibleTaskGroup';
